<template>
  <div>
    <h2><i>Videos</i></h2>

    <section>
      <interview-video :issue="issue"></interview-video>
    </section>

  </div>
</template>

<style scoped lang="scss">
  section {
    margin: 20px auto;
    padding-bottom: 12px;
    &:not(:last-child) {
     border-bottom: 1px solid #cccccc;
    }
  }
</style>

<script>
  import InterviewVideo from '@/components/shared/InterviewVideoComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  export default {
    name: 'interact-video',
    components: {
      InterviewVideo
    },
    mixins: [ UtilityMixin ],
    data () {
      return {
        issues: {}
      }
    },
    created () {
      this.$parent.$parent.prevPage = {name: 'article-metrics'}
      this.$parent.$parent.nextPage = {name: 'article-media'}
      this.$parent.$parent.prevSlide = {name: 'article-interact-figures'}
      this.$parent.$parent.nextSlide = {name: 'article-interact-trivia'}

      this.issue = this.getStaticPath('mocks/video-list.json').videos[0]
    }
  }
</script>



// WEBPACK FOOTER //
// InteractVideoPage.vue?3b0303db